<template>
  <div>
  <card v-loading="loading" :title="$t('posTransactionPage.title')">
    <span v-if="error">{{ JSON.stringify(error) }}</span>
    <span v-else-if="details">
      <pos-transaction-details :details="details"/>
    </span>
  </card>
    <div v-if="details">
      <pos-operations-table :details="details.operations" />
    </div>
  </div>
</template>
<script>
import PosTransactionDetails from "src/components/PosTransaction/PosTransactionDetails";
import PosOperationsTable from '../PosOperations/PosOperationsTable'
import {mapActions, mapState} from "vuex";

export default {
  name: 'posTransactionPage',
  components: {
    PosTransactionDetails,
    PosOperationsTable
  },
  methods: {
    ...mapActions(['LoadPosTransaction'])
  },
  computed: {
    ...mapState({
      loading: state => state.pos_transaction.loading,
      details: state => state.pos_transaction.data,
      error: state => state.pos_transaction.error,
    }),
  },
  mounted() {
    if (this.details === null || this.details.id != this.$route.params.id) {
      this.LoadPosTransaction({id: this.$route.params.id})
    }
  }
};
</script>
<style>
</style>
